import { useEffect, useRef, useCallback } from 'react'

/**
 * Hook per logout automatico dopo inattività
 * @param {Function} onLogout - Callback da eseguire al logout
 * @param {number} timeout - Timeout in ms (default 30 minuti)
 */
export function useIdleLogout(onLogout, timeout = 30 * 60 * 1000) {
  const timerRef = useRef(null)
  const onLogoutRef = useRef(onLogout)

  useEffect(() => {
    onLogoutRef.current = onLogout
  }, [onLogout])

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      onLogoutRef.current()
    }, timeout)
  }, [timeout])

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']
    
    // Reset timer su ogni attività
    events.forEach(event => {
      document.addEventListener(event, resetTimer, { passive: true })
    })

    // Start timer iniziale
    resetTimer()

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimer)
      })
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [resetTimer])
}
